import React, { useState, useEffect, useCallback } from 'react'

// Partials
import Btn from 'views/shared/partials/btn'
import Loader from 'views/shared/partials/loader'
import Pricebox from 'views/shared/partials/pricebox'
import Image from 'views/shared/partials/image'

// Utils
// import { openModal } from 'utils/modals'

// Functions
import parseHtml from 'functions/parse-html'
import formatDate from 'functions/format-date'

// Sections
import Breadcrumbs from 'views/admin/sections/breadcrumbs'
import ProductStockList from 'views/admin/sections/product-stock-list'

// Services
import commerceServices from 'services/commerce'

const ProductDetail = (props) => {
	const productID = props.match.params.id;

	const [product, setProduct] = useState(false);

	const getData = useCallback(() => {
		setProduct(false);
		commerceServices.getProduct(productID).then((payload) => {
			setProduct(payload);
			// setProduct({
			// 	...payload,
			// 	store_stock: [...payload.store_stock, ...payload.store_stock, ...payload.store_stock, ...payload.store_stock, ...payload.store_stock, ...payload.store_stock]
			// });
		});

		// getInstallmentOptions(accountID);
	}, [productID]);

	useEffect(() => {
		getData();
	}, [productID, getData])

	return (
		<main className="page company-payment-type-detail">
			<Breadcrumbs
				midSections={[
					{href: 'products'}
				]} />
			<section className="portlet section detail-info loader-container">
				<Loader loading={!product} />
				{product &&
					<React.Fragment>
						<div className="portlet-header">
							<h1 className="portlet-title">
								<p className="title-toptext">
									{product.brand}
								</p>
								{product.title}
								<span className="title-subtitle">#{product.mpn}</span>
							</h1>

							<div className="header-controls">
								<Btn
									white small wide
									tag="a"
									href={product.link}
									target="_blank"
									icon="link">
									Ürün Sayfasına Git
								</Btn>
							</div>
						</div>

						<div className="portlet-section">
							<div className="portlet-infobar">
								<div className="grid-container">
									<div className="row">
										<div className="col x2 m-x6">
											<div className="infobar-section">
												<strong className="section-title">Ürün Görseli</strong>
												<span className="section-data">
													<div className="image-box size-small">
														<Image src={product.image_link} />
													</div>
												</span>
											</div>
										</div>
										<div className="col x3 m-x6">
											<div className="infobar-section">
												<strong className="section-title">Ürün Fiyatı</strong>
												<span className="section-data">
													<Pricebox price={product.price} />
												</span>
											</div>
										</div>
										<div className="col x6">
											<div className="infobar-section">
												<strong className="section-title">Kategori</strong>
												<span className="section-data">
													{parseHtml(product.product_type)}
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="portlet-section bottom border-top">
							<div className="portlet-infobar horizontal">
								<div className="grid-container">
									<strong className="infobar-title">Ürün Bilgileri</strong>
									<div className="row">
										<div className="col x6">
											<div className="infobar-section">
												<strong className="section-title">Marka</strong>
												<span className="section-data">
													{product.brand ? product.brand : '-'}
												</span>
											</div>

											<div className="infobar-section">
												<strong className="section-title">MPN</strong>
												<span className="section-data">
													{product.mpn ? product.mpn : '-'}
												</span>
											</div>

											<div className="infobar-section">
												<strong className="section-title">GTIN</strong>
												<span className="section-data">
													{product.gtin ? product.gtin : '-'}
												</span>
											</div>
										</div>
										<div className="col x6">
											<div className="infobar-section">
												<strong className="section-title">Oluşturulma Tarihi</strong>
												<span className="section-data">
													{product.created_at ? formatDate(product.created_at) : '-'}
												</span>
											</div>
											<div className="infobar-section">
												<strong className="section-title">Güncelleme Tarihi</strong>
												<span className="section-data">
													{product.updated_at ? formatDate(product.updated_at) : '-'}
												</span>
											</div>
										</div>
									</div>
									<strong className="infobar-title">Ürün Açıklaması</strong>
									<div className="row">
										<div className="col">
											<div className="infobar-section">
												<div className="section-data full">
													{product.description ? parseHtml(product.description) : '-'}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</React.Fragment>
				}
			</section>

			{(product && product.store_stock && product.store_stock.length > 0) &&
				<ProductStockList stockInfo={product.store_stock} />
			}
		</main>
	)
}

export default ProductDetail